import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ action }) => {
  const priorityColors = {
    high: 'border-error/30 bg-error/5',
    medium: 'border-warning/30 bg-warning/5',
    normal: 'border-border bg-card'
  };

  const priorityBadgeColors = {
    high: 'bg-error/10 text-error',
    medium: 'bg-warning/10 text-warning',
    normal: 'bg-muted text-muted-foreground'
  };

  return (
    <button
      onClick={action?.action}
      className={`w-full text-left rounded-2xl p-4 border-2 transition-all hover:elevation-sm ${
        priorityColors?.[action?.priority] || priorityColors?.normal
      }`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
          <Icon name={action?.icon} size={20} color="#FFFFFF" />
        </div>
        {action?.priority !== 'normal' && (
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            priorityBadgeColors?.[action?.priority]
          }`}>
            {action?.priority?.toUpperCase()}
          </span>
        )}
      </div>
      <h3 className="text-base font-semibold text-foreground mb-1">{action?.title}</h3>
      <p className="text-sm text-muted-foreground">{action?.description}</p>
    </button>
  );
};

export default QuickActionCard;